import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { ApitypePortResponse2 } from "api/generated/v2/models";

type NonNullPort = NonNullable<ApitypePortResponse2>;

type GlobalPortType = {
  id: NonNullPort["id"];
  name: NonNullPort["name"];
  location: NonNullPort["location"];
  unloCode: NonNullPort["unloCode"];
  timeZone: NonNullPort["timeZone"];
};

export type GlobalPortState = {
  port: (GlobalPortType & { userId: string | undefined }) | null;
};

type GlobalPortStore = {
  setPort: (newPort: NonNullPort, userId: string | undefined) => void;
  resetPort: () => void;
} & GlobalPortState;

const useGlobalPort = create<GlobalPortStore>()(
  persist(
    (set) => ({
      port: null,
      setPort: (newPort, userId) =>
        set({
          port: {
            id: newPort.id,
            location: newPort.location,
            name: newPort.name,
            unloCode: newPort.unloCode,
            timeZone: newPort.timeZone,
            userId,
          },
        }),
      resetPort: () => set({ port: null }),
    }),
    {
      name: `global-port-store`,
      version: 2,
    },
  ),
);

export { useGlobalPort };
